<div [style]="customStyle">
  <p-calendar #yearCalendar [(ngModel)]="selectedDate" view="year" dateFormat="yy" [placeholder]="placeholder" [ngClass]="{
    'calendar-default': size === 'default',
    'calendar-compact': size === 'compact',
    'calendar-xs': size === 'xs'
  }" (onSelect)="onDateSelected()" (onInput)="onDateSelected()"/>
</div>

<div class="error">
  <app-error [control]="control"></app-error>
</div>
